import { Link } from "react-router-dom";
import Header from "../components/Header";
import sodu1 from "@/assets/img/sodu/sodu1.png";
import { useTranslation } from "react-i18next";
const SoDu = () => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  return (
    <div className="wrapper">
      <div className="container-web sodu bgnew">
        <div className="header-sodu">
          <Header title={t("Danh sách sản phẩm")} />

          <div className="mt-3 position-relative">
            <img className="w-100" src={sodu1} />
            <div className="position-absolute top-0 end-0 px-5 mt-4 bottom-0 start-0">
              <div
                className="text-center d-flex flex-column align-items-center gap-1"
                style={{ color: "#cc964f" }}
              >
                <span style={{ fontSize: 14 }}>0.00</span>
                <span
                  style={{
                    fontSize: 10,
                    border: "1px solid #cc964f",
                    padding: "1px 7px",
                  }}
                >
                  {t("Đang được lưu trữ")}
                </span>
              </div>

              <div
                className="d-flex mt-2"
                style={{ fontSize: 12, color: "#fff" }}
              >
                <div className="d-flex flex-column w-100 text-center gap-1">
                  <span
                    style={{
                      color: "#cc964f",
                      fontWeight: "bold",
                      fontSize: 14,
                    }}
                  >
                    0.00
                  </span>
                  <span style={{ lineHeight: "1.2" }}>{t("Thu nhập hàng ngay")}</span>
                </div>
                <div className="d-flex flex-column w-100 text-center gap-1">
                  <span
                    style={{
                      color: "#cc964f",
                      fontWeight: "bold",
                      fontSize: 14,
                    }}
                  >
                    0.00
                  </span>
                  <span style={{ lineHeight: "1.2" }}>{t("Thu nhập hàng ngay")}</span>
                </div>

                <div className="d-flex flex-column w-100 text-center gap-1">
                  <span
                    style={{
                      color: "#cc964f",
                      fontWeight: "bold",
                      fontSize: 14,
                    }}
                  >
                    0.00
                  </span>
                  <span style={{ lineHeight: "1.2" }}>{t("Thu nhập hàng ngay")}</span>
                </div>
              </div>

              <div className="d-flex mt-3 justify-content-around">
                <Link
                  to={"/"}
                  style={{ background: "#d09e59", fontSize: 12 }}
                  className="px-4 py-1 rounded-5 text-decoration-none text-black"
                >
                  {t("Đặt hàng")}
                </Link>
                <Link
                  to={"/"}
                  style={{ background: "#d09e59", fontSize: 12 }}
                  className="px-4 py-1 rounded-5 text-decoration-none text-black"
                >
                  {t("Luật lệ")}M
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoDu;
